import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import LatestArticles from './components/LatestArticles';
import TrendingSidebar from './components/TrendingSidebar';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />

        {/* Main Content Area */}
        <div className="w-full px-4 md:px-6">
          <div className="flex flex-col lg:flex-row gap-8 py-10 md:py-14">
            {/* Main Column */}
            <div className="flex-1 min-w-0">
              <LatestArticles />
            </div>

            {/* Sidebar */}
            <div className="w-full lg:w-[340px] shrink-0">
              <div className="lg:sticky lg:top-20">
                <TrendingSidebar />
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />

      {/* Organization Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '吃瓜黑料在线',
            url: 'http://dlhuayan.cn/',
            description: '吃瓜黑料在线网站提供最新的网红塌房、明星八卦、独家爆料等内容，打造实时更新的吃瓜黑料聚集平台。',
            sameAs: [],
          }),
        }}
      />

      {/* WebSite Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '吃瓜黑料在线',
            url: 'http://dlhuayan.cn/',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'http://dlhuayan.cn/?search={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />

      {/* WebPage Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '吃瓜黑料在线 - 首页',
            description: '吃瓜黑料在线网站提供吃瓜黑料在线入口，涵盖51吃瓜网在线观看、91在线吃瓜、黑料吃瓜在线等爆款内容。专注网红塌房现场、博主反差视频及独家吃瓜爆料。',
            url: 'http://dlhuayan.cn/',
            isPartOf: {
              '@type': 'WebSite',
              name: '吃瓜黑料在线',
            },
          }),
        }}
      />
    </>
  );
}